<div class="grid-container">
<domains-list-view></domains-list-view>

<undelegated-domains-list-view [newDelegationDomains]="newDelegationDomains" *ngIf="newDelegationDomains.length>0"></undelegated-domains-list-view>
<div class="content-header">Change Requests</div>
<p class="header-helper">
  This is a list of change requests that relate to the domains you manage. To view, select the change request.
</p>
<div class="content content-with-elevation">
  <div class="grid-x">
    <div class="cell large-2 medium-12 small-12 filter-group">
      <fa-icon [icon]="'filter'" style="margin-right: 5px;"></fa-icon>
      <select [(ngModel)]="filterOptionSelected" (change)="changeFilter()" class="select-box">
        <option *ngFor="let myOption of filterOptions" [value]="myOption.key">
          {{ myOption.value }}
        </option>
      </select>
    </div>
    <div class="cell large-2 medium-0 small-0"></div>
    <div class="cell large-3 medium-12 small-12  search-group">
      <input placeholder="Search" [(ngModel)]="searchText" class="filter" (keydown)="onKeydown($event)">
      <a (click)="search()" class="search-button">
        <fa-icon [icon]="'search'" style="align-self: center"></fa-icon>
      </a>
    </div>
    <div class="cell large-5 medium-0 small-0"></div>
  </div>
  <div class="table-scroll" infiniteScroll
       [infiniteScrollDistance]="2"
       [infiniteScrollThrottle]="150"
       (scrolled)="onScroll()">
    <table class="responsive-card-table unstriped hover iana-table" *ngIf="changeRequests.length >0">
      <thead>
      <tr>
        <th style="width:15%">Request</th>
        <th style="width:15%">Domain</th>
        <th style="width:40%">Summary</th>
        <th style="width:30%">Status</th>
        <th style="width:30%">Created On</th>
      </tr>
      </thead>
      <tbody>
      <tr class="spaceUnder" *ngFor="let changeRequest of changeRequests">
        <td data-label="Request" class="a-link-no-underline"><a
          (click)="navigateToRequestDetailsPage(changeRequest)">{{changeRequest.id}}</a></td>
        <td data-label="Domain" class="a-link-no-underline">
          <a (click)="editDomain(changeRequest)">{{changeRequest.tldName | domainNameConverter}}</a>
        </td>
        <td data-label="Summary">
          {{changeRequest.requestMetadata.requestSummary}}
        </td>
        <td data-label="Status">
          {{changeRequest.statusName}}
        </td>
        <td data-label="Created On">{{changeRequest.requestMetadata?.dateOfSubmission | commonDate }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

  <div class="content-header">Contacting IANA</div>
  <p class="header-helper">
    If you have questions, please contact us at <a href="mailto:root-mgmt@iana.org">root-mgmt&#64;iana.org</a>.
    <br>
    For emergency change requests when a top level domain is no longer resolving, please lodge your change request
    here first and then contact our emergency call center at <a href="tel:+1-310-306-6308">+1 310 306 6308</a>.
  </p>

</div>

